import SkeletonTable from "@/components/SkeletonTable";
import { getListNilaiCbt } from "@/services/getData";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useTahun } from "@/hooks/useTahun";

export default function SyncNilaiCbtPage() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || "1";
  const rowsPerPage = searchParams.get("rowsPerPage") || "10";
  const search = searchParams.get("search") || "";
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listNilaiCbt", page, rowsPerPage, search, selectedTahun?.value],
    queryFn: () =>
      getListNilaiCbt(page, rowsPerPage, search, selectedTahun?.value),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
      />
    </div>
  );
}
